import { DEFAULT_NETWORK_TEST_NUMBER } from '../constants/networkTest';

const digitsOnly = (s: string) => s.replace(/\D/g, '');

/**
 * True if a webphone `remoteIdentity` (or similar) refers to the network test dial endpoint.
 */
export function matchesNetworkTestDial(remoteIdentity: string): boolean {
  if (!remoteIdentity?.trim()) {
    return false;
  }
  const remoteDigits = digitsOnly(remoteIdentity);
  const testDigits = digitsOnly(DEFAULT_NETWORK_TEST_NUMBER);
  if (!testDigits.length) {
    return false;
  }
  return (
    remoteDigits === testDigits ||
    remoteDigits.endsWith(testDigits) ||
    remoteDigits.includes(testDigits)
  );
}
